const TYPOGRAPHY_REPLACEMENTS: [RegExp, string][] = [
  [/[\u2018\u2019]/g, `'`],
  [/[\u201C\u201D]/g, '"'],
  [/\u2014/g, '--'],
  [/\u2013/g, '-'],
  [/\u2026/g, '...'],
  [/\u00AB/g, '<<'],
  [/\u00BB/g, '>>'],
  [/\u00A0/g, ' '],
];

export function sanitiseSmsBody(text: string): string {
  return TYPOGRAPHY_REPLACEMENTS.reduce(
    (result, [pattern, replacement]) => result.replace(pattern, replacement),
    text
  );
}
